/**
 * Cyber security metrics constants
 */
export const SENDER_BPN = 'BPNL000000000ISY';
